/**
 * Created by wscott on 10/2/2017.  Machine: {wolfdev2}
 *
 *  Revision History for Api ::
 *
 *      Initial Writing: 10/2/2017        wjscott
 *      ------------------------------------------------------------------------
 *
 *       1. Attach x-access-token from sessionStorage on each request (refresh-safe)
 */

import axios from 'axios';
import constants from '@/constants';
import { getStoredToken } from '@/services/Session';

export default () => {
  const instance = axios.create({
    baseURL: constants.PORTAL_APIURL,
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'applicationKey': '00000-10000-00000-00000-00030',
    },
  });

  instance.interceptors.request.use((config) => {
    const token = getStoredToken();
    if (token) {
      config.headers['x-access-token'] = token;
    }
    return config;
  });

  return instance;
};
